import type { ObservationStatus } from '../types/text-mode.types';

export const OBSERVATION_STATUS_LABEL_TOKENS: Record<ObservationStatus, string> = {
  positive: 'app.assessment_mode.text.input.option.yes',
  negative: 'app.assessment_mode.text.input.option.no',
  unknown: 'app.assessment_mode.text.input.option.unknown',
};

export const OBSERVATION_STATUS_OPTIONS: Array<{
  value: ObservationStatus;
  labelToken: string;
}> = [
  { value: 'positive', labelToken: OBSERVATION_STATUS_LABEL_TOKENS.positive },
  { value: 'negative', labelToken: OBSERVATION_STATUS_LABEL_TOKENS.negative },
  { value: 'unknown', labelToken: OBSERVATION_STATUS_LABEL_TOKENS.unknown },
];
